import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import api, { fileUrl, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function ResetPassword() {
  const { branding } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) { setError("Passwords do not match."); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated — please sign in");
      navigate("/auth", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="phone-wrap">
      <div className="phone-frame flex flex-col">
        <img src={fileUrl(branding?.login_hero)} alt="Alpha Tattoo Club" className="w-full h-44 object-cover border-b-2 border-black" />
        <div className="p-6 flex-1">
          <span className="eyebrow">Account Recovery</span>
          <h1 className="font-display font-black text-3xl uppercase leading-none mb-4">New Password</h1>
          {!token ? (
            <div className="atc-card p-5">
              <p className="text-sm">This reset link is missing its token. Request a new one.</p>
              <button className="atc-btn btn-primary w-full mt-4" onClick={() => navigate("/forgot-password")} data-testid="reset-request-new">Request New Link</button>
            </div>
          ) : (
            <form onSubmit={submit} className="flex flex-col gap-3">
              <input className="atc-input" type="password" placeholder="New password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="reset-password" />
              <input className="atc-input" type="password" placeholder="Confirm new password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required data-testid="reset-confirm" />
              {error && <p className="text-[#8B1E28] text-sm font-bold" data-testid="reset-error">{error}</p>}
              <button type="submit" className="atc-btn btn-primary" disabled={busy} data-testid="reset-submit">
                {busy ? <Loader2 size={18} className="animate-spin" /> : null} Update Password
              </button>
              <button type="button" className="w-full text-center mt-1 font-mono2 text-xs underline text-[#554E40]" onClick={() => navigate("/auth")} data-testid="reset-back-link">Back to sign in</button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
